// 库加载即执行的 token 统一逻辑
// 把不同平台散落在不同位置/key 的 token 统一写入 cookie JX_http_usertoken
// 业务方后续统一从 JX_http_usertoken 取 token，无需关心平台差异
import { detect } from './detector.js';
import { Platform } from '../platforms.js';

// 统一存放的 cookie key
const UNIFY_COOKIE_KEY = 'JX_http_usertoken';
// 微信/企业微信的 token 来源 cookie key
const CXH5_STRATEGY_INFO_KEY = 'cxh5-token-info';

// 读 cookie 值（已 decodeURIComponent）
function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : '';
}

// 写 cookie（path=/，不显式设 domain 和 expires，跟随当前域 + session 级）
function setCookie(name, value) {
  document.cookie = name + '=' + encodeURIComponent(value) + ';path=/';
}

// 微信/企业微信：从 cxh5-strategy-info 提取 token
// cookie 原值是 encodeURIComponent 编码的 JSON 字符串
// 解析流程：读 cookie（getCookie 内部已 decode）→ JSON.parse → 取 .token
function extractTokenFromCxh5() {
  const raw = getCookie(CXH5_STRATEGY_INFO_KEY);
  if (!raw) return '';
  const obj = JSON.parse(raw);
  if (!obj || typeof obj !== 'object') return '';
  const token = obj.token;
  return token ? String(token) : '';
}

// 各平台 token 提取处理函数
// - jiyibao: 跳过（本身已写在 JX_http_usertoken）
// - wxa / kuaibao / browser: 占位，逻辑后续补充
const platformHandlers = {
  [Platform.JIYIBAO]: null,
  [Platform.WEIXIN]: extractTokenFromCxh5,
  [Platform.WXWORK]: extractTokenFromCxh5,
  [Platform.WXA]: null,
  [Platform.KUAIBAO]: null,
  [Platform.BROWSER]: null
};

function unifyToken() {
  try {
    const platform = detect();
    const handler = platformHandlers[platform];
    // 当前平台无处理逻辑：jiyibao 跳过 / wxa / kuaibao / browser 占位待补
    if (typeof handler !== 'function') return;

    const token = handler() || '';
    if (!token) {
      console.warn('[JXBridge] unifyToken: 未取到 token，platform=' + platform + '，保留原 JX_http_usertoken');
      return;
    }
    setCookie(UNIFY_COOKIE_KEY, token);
  } catch (err) {
    // 解析失败兜底：不让异常逃逸到全局，避免阻塞业务方页面加载
    console.warn('[JXBridge] unifyToken 失败:', err && err.message);
  }
}

// 模块加载即执行
unifyToken();
